import request from '@/utils/request'

/**
 * 上传文件
 * @param {FormData} formData 文件数据
 */
export function uploadFileApi(formData) {
  return request({
    url: '/common/file/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}